import { VdTracking } from '@vend/vend.js'
import { IScope } from 'angular'

import { EVENTS } from '../../../constants'
import { SaleSyncManager } from '../../../managers/sale-sync-manager'
import { WebRegisterStatusManager } from '../../../managers/web-register-status-manager'
import { $sce } from '../../../ng-compat/imports'
import { WEB_REGISTER } from '../../web-register.constant'

/**
 * Controller class for the errored sales modal
 *
 * @class ErroredSalesModalController
 */
export class ErroredSalesModalController {
  public contactSupportUrl: $TSFixMe
  public erroredSales: $TSFixMe
  public erroredSalesButton: $TSFixMe
  constructor(
    $scope: IScope,
    public close: $TSFixMe,
    public options: $TSFixMe,
    public saleSyncManager: SaleSyncManager,
    public webRegisterStatusManager: WebRegisterStatusManager,
    public vdTracking: VdTracking
  ) {
    'ngInject'
    vdTracking.trackUserEvent({
      eventName: 'Errored Sales Modal',
      metadata: {
        Event: 'Modal Shown',
      },
    })
    this.contactSupportUrl = WEB_REGISTER.CONTACT_SUPPORT_URL
    this.erroredSales = options.erroredSales
    this.erroredSalesButton = $sce.trustAsHtml(`
      <a href="${options.erroredSalesFileUrl}"
        download="errored-sales.json"
        target="_blank"
        class="vd-btn vd-btn--supplementary">
        Download sale info
      </a>`)

    saleSyncManager.on(
      'saleSyncRetryComplete',
      this._evaluateErroredSales,
      this
    )
    webRegisterStatusManager.on(EVENTS.statusChange, this.close, this)

    $scope.$on('$destroy', () => {
      saleSyncManager.off('saleSyncRetryComplete', this._evaluateErroredSales)
      webRegisterStatusManager.off(EVENTS.statusChange, this.close)
    })
  }

  /**
   * Evaluates the current collection of errored sales.
   *
   * @private
   * @method _evaluateErroredSales
   */
  private _evaluateErroredSales() {
    this.saleSyncManager.getErroredSales().then((erroredSales: $TSFixMe) => {
      if (erroredSales.length) {
        this.erroredSales = erroredSales
      } else {
        this.close()
      }
    })
  }
}
